import { useLoaderData } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { useSearchParams } from '../../../../../common/hooks/useSearchParams';
import { useTitle } from '../../../../../common/hooks/useTitle.js';
import { omaElisaForEmployeeMsg, orderRequestsMsg, t } from '../../../../../common/i18n/index.js';
import { CustomerOrderListWithTable } from '../../../../../components/CustomerOrderList/CustomerOrderListWithTable';
import { EoeOrdersBreadcrumb, EoeOrdersNavi } from '../../../../../components/EoeOrdersWrapper/EoeOrdersWrapper.js';
import { Grid } from '../../../../../components/Grid/Grid.js';
import { useAuth } from '../../../AuthProvider';
import type { CustomerOrdersResponse } from '../../../../../generated/api/customerOrdersResponse';

export const EoeFinishedReviewsPath = () => {
  const { authenticatedUser } = useAuth();
  const { searchResults, resultCountAggregations, total } = useLoaderData() as CustomerOrdersResponse;

  const { search, status } = useSearchParams<{
    offset?: string;
    order?: string;
    search?: string;
    status?: string;
    sort?: string;
  }>();

  useTitle([t.H6JV(omaElisaForEmployeeMsg), t.Y29L(orderRequestsMsg)]);

  return (
    <>
      <EoeOrdersBreadcrumb />
      <EoeOrdersNavi />
      <Grid>
        <CustomerOrderListWithTable
          basePath={paths.EMPLOYEE_FINISHED_REVIEW_ORDER}
          customerOrders={searchResults}
          aggregations={resultCountAggregations}
          loading={false}
          totalItems={total}
          status={status}
          searchQuery={search}
          authenticatedUser={authenticatedUser}
          noFilters={true}
        />
        <p>
          <strong>{t.FZU3(`Can't you see your order here?`)}</strong>{' '}
          {t.QZZR('If you just placed it, no worries. The order will appear here with a little delay.')}
        </p>
      </Grid>
    </>
  );
};
